var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7a5 5 0 1 1 10 0A5 5 0 0 1 2 7Zm12.295 8.7a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.43l-3.08-3.08a7.03 7.03 0 1 0-1.42 1.42l3.09 3.09Z"
  })));
};
export default SvgMagnifyingGlass;